import { useEffect } from 'react';

function notifyToSlackChannel(webHookURL, message, channel, userName, botIconURL) {
  useEffect(function () {
    if (webHookURL && webHookURL.trim() && message && message.trim()) {
      var payload = {
        text: message
      };

      if (channel && channel.trim()) {
        payload.channel = channel;
      }

      if (userName && userName.trim()) {
        payload.username = userName;
      }

      if (botIconURL && botIconURL.trim()) {
        payload.icon_url = botIconURL;
      }

      fetch(webHookURL, {
        method: 'post',
        body: JSON.stringify(payload)
      }).then(function (response) {
        return response;
      }).then(function (response) {
        return response;
      })["catch"](function (error) {
        return error;
      });
    }
  }, [webHookURL, userName, message, channel, botIconURL]);
  return null;
}

export default notifyToSlackChannel;
//# sourceMappingURL=index.modern.js.map
